<template>
	<div class="footer-item-wrapper">
		<div
			class="footer-item surf-transition-footer-item"
			:class="{
				'has-children': hasDropdownContent,
				active: isMenuActive
			}"
			@click="handleItemClick"
		>
			<div class="footer-item-name">{{ menu.name }}</div>
			<!-- 暂时隐藏，设计稿没有 -->
			<!-- <SvgIcons v-if="hasDropdownContent" name="down" class="footer-item-arrow" /> -->
		</div>

		<!-- 下拉内容：子菜单和模块 -->
		<div v-if="hasDropdownContent" class="footer-nav-content">
			<!-- 子菜单 -->
			<template v-if="hasSubMenus">
				<FooterMenuItemMob
					v-for="subMenu in menu.pageMenuVOS"
					:key="subMenu.uuid"
					:menu="subMenu"
					@click="$emit('click', $event)"
				/>
			</template>

			<!-- 模块列表 -->
			<template v-if="hasModules">
				<div
					v-for="module in menu.moduleVOS"
					:key="module.moduleId"
					class="footer-module-item surf-transition-footer-item"
					@click.stop="handleModuleClick(module)"
				>
					<div class="footer-item-module-name">{{ module.name }}</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SurfFooterMenuItemMob'
};
</script>
<script setup>
import FooterMenuItemMob from './FooterMenuItemMob.vue';
import { computed } from 'vue';
import { useDisplayLogic } from '@rebuild/materials/shared/page_container/useDisplayLogic';
import {
	checkChildrenMenus,
	checkChildrenModules,
	checkMenuActive,
	resolveDefaultMenu,
	isOverviewMenu
} from '@rebuild/materials/shared/layout_nav/surf/useNavMenu';

const props = defineProps({
	menu: {
		type: Object,
		required: true
	}
});
const currentMenu = computed(() => props.menu);
const emit = defineEmits(['click']);

const { displayMenu, displayModule } = useDisplayLogic();

const hasSubMenus = computed(() => checkChildrenMenus(currentMenu.value));
const hasModules = computed(() => checkChildrenModules(currentMenu.value));
const hasDropdownContent = computed(() => {
	if (isOverviewMenu(currentMenu.value)) return false;
	return hasSubMenus.value || hasModules.value;
});

// ############ 选中状态 Start #############
// 判断菜单是否选中
const isMenuActive = computed(() => {
	return checkMenuActive(currentMenu.value, displayMenu.value, displayModule.value);
});
// ############ 选中状态 End #############

const handleItemClick = () => {
	const defaultMenu = resolveDefaultMenu(currentMenu.value);
	emit('click', { menu: defaultMenu });
};
const handleModuleClick = module => {
	emit('click', { menu: currentMenu.value, module });
};
</script>

<style lang="less" scoped>
.surf-transition-footer-item {
	transition: all 0.3s ease;
}

.footer-item-wrapper {
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

// 最外层菜单项样式
.footer-item-wrapper > .footer-item {
	display: flex;
	align-items: center;
	gap: 4px;
	cursor: pointer;
	font-size: 15px;
	color: var(--surf-inverse-color);
	font-weight: 500;
	line-height: 24px;

	&:hover,
	&.active {
		color: var(--surf-inverse-color) !important;
	}

	.footer-item-arrow {
		flex-shrink: 0;
		color: var(--surf-inverse-color) !important;
		font-size: 16px;
	}
}

.footer-nav-content {
	display: flex;
	flex-direction: column;
	gap: 20px;

	.footer-item-wrapper {
		gap: 20px;
	}

	// 嵌套菜单项样式
	.footer-item-wrapper > .footer-item {
		font-size: 12px;
		color: rgba(var(--surf-inverse-color-rgb), 0.4);
		font-weight: 400;
		line-height: 16px;

		&:hover {
			color: rgba(var(--surf-inverse-color-rgb), 0.7);
		}

		.footer-item-arrow {
			font-size: 16px;
			color: rgba(var(--surf-inverse-color-rgb), 0.6) !important;
		}
	}

	// 模块项样式
	.footer-module-item {
		cursor: pointer;
		font-size: 12px;
		color: rgba(var(--surf-inverse-color-rgb), 0.4);
		font-weight: 400;
		line-height: 16px;

		&:hover {
			color: rgba(var(--surf-inverse-color-rgb), 0.7);
		}
	}
}

.footer-item-name {
	width: 100%;
	text-align: left;
	// todo check width
	// max-width: 60px;
}
.footer-module-item {
	width: 100%;
	text-align: left;
	// todo check width
	// max-width: 60px;
}
</style>
